import styled from 'styled-components';
import UnderlineSelected from '../UI/UnderlineSelected';

const DepartmentText = styled(UnderlineSelected)`
  font-size: ${({ fontSize }) => fontSize || '15px'};
  font-family: ${({ active }) =>
    active ? '"Avenir Black", "Arial Black", sans-serif' : '"Avenir Light", "Arial", sans-serif'};
  font-weight: ${({ active }) => (active ? 'bold' : 300)};
  ${({ underline, active }) =>
    underline && active
      ? `
    border-bottom: 3px solid #000;
    display: block;
  }`
      : null}
  &:hover {
    font-weight: bold;
    font-family: 'Avenir Black', 'Arial Black', sans-serif;
  }
  &::after {
    font-family: 'Avenir Black', 'Arial Black', sans-serif;
    display: block;
    content: attr(title);
    font-weight: bold;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

export default DepartmentText;
